import React from 'react';
import classNames from 'classnames/bind';
import { emptyObj } from '@beef/utils';
import { Device } from "../../../Device";
import style from "../../styles.module.pcss";
var cn = classNames.bind(style);
export var Wrapper = function Wrapper(_ref) {
  var className = _ref.className,
    isFetching = _ref.isFetching,
    children = _ref.children,
    previewCardsLength = _ref.previewCardsLength,
    rowsSpace = _ref.rowsSpace,
    contentMaxWidth = _ref.contentMaxWidth,
    isEmpty = _ref.isEmpty,
    nodeEmptyList = _ref.nodeEmptyList;
  if (isFetching) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('wrapper', contentMaxWidth && "wrapper--content-".concat(contentMaxWidth), rowsSpace && "row--space-".concat(rowsSpace), className)
    }, Array.from(Array(previewCardsLength).keys()).map(function (device) {
      return /*#__PURE__*/React.createElement(Device, {
        device: emptyObj,
        isFetching: true,
        key: device
      });
    }));
  }
  if (!isFetching && isEmpty && nodeEmptyList) {
    return nodeEmptyList;
  }
  return children;
};